import { inject, observer } from 'mobx-react';
import React, { PropTypes } from 'react';
import Form, { DateInput, FormActions, FormBody, SelectInput } from '../Form';
import { action, observable } from 'mobx';
import moment from 'moment';
import * as api from '../../actions/api';
import Spinner from '../Spinner';
import GraphView from '../GraphView';
import _ from 'lodash';
import { getDisplayDate } from '../../libs/date';
import DataTable from '../DataTable';

@inject('stationStore', 'dataSeriesStore', 'parameterStore')
@observer
class Evaporation extends React.Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    params: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
  };

  @observable filters = {
    station_id: null,
    evaporation_id: null,
    pcpn_id: null,
    date_from: moment().add(-7, 'days').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
  }
  @observable loading = false;
  @observable dataSeriesItems = [];
  @observable graph = true;

  state = {
    options: null,
    csv: '',
    table: '',
  }

  tableCols = [
    { label: 'Date', key: 'datetime' },
    { label: 'Hourly Evaporation', key: 'epl_1h' },
    { label: 'Hourly Rainfall', key: 'pcpn' },
    { label: 'Net Evaporation', key: 'evaporation' },
  ];

  componentDidMount() {
    this.urlData();
  }

  urlData() {
    const currentUrl = window.location.href;
    const queryParams = new URLSearchParams(currentUrl.split('?')[1]);
    const station_id = queryParams.get('station_id');
    const evaporation_id = queryParams.get('evaporation_id');
    const pcpn_id = queryParams.get('pcpn_id');
    const date_from = queryParams.get('date_from');
    const date_to = queryParams.get('date_to');
    console.log(station_id, evaporation_id, pcpn_id, date_from, date_to);
    if (station_id && evaporation_id && pcpn_id && date_from && date_to) {
      this.onChangeStationFilter({ target: { value: station_id } });
      this.filters.evaporation_id = evaporation_id;
      this.filters.pcpn_id = pcpn_id;
      this.filters.date_from = date_from;
      this.filters.date_to = date_to;
      this.onView({ preventDefault: () => { } });
    }
  }

  @action onChangeFilter = (key, e) => this.filters[key] = e.target.value;

  @action onChangeStationFilter = (e) => {
    const { notify } = this.context;
    const { stationStore, parameterStore } = this.props;
    const stationId = e.target.value;
    this.filters.station_id = stationId;
    stationStore.fetchDataSeries(stationId)
      .then(action(dataSeriesItems => {
        this.dataSeriesItems = dataSeriesItems
          .sort((a, b) => a.name > b.name ? 1 : -1)
          .map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
        // this.onChangeSeries({target: {value: 5500}});
      }))
      .catch(notify.error);
  }

  onView = e => {
    e.preventDefault();
    const { notify, router } = this.context;
    const { station_id, pcpn_id, evaporation_id, date_from, date_to } = this.filters;
    this.loading = true;

    const pcpnFilters = {
      series_id: pcpn_id,
      date_from: date_from,
      date_to: date_to,
    }

    const evaporationFilters = {
      series_id: evaporation_id,
      date_from: date_from,
      date_to: date_to,
    }
    router.push({
      pathname: `/analysis/evaporation`,
      query: { station_id, pcpn_id, evaporation_id, date_from, date_to }
    });

    Promise.all([
      api.observation.fetchAll(pcpnFilters),
      api.observation.fetchAll(evaporationFilters),
    ]).then(res => {
      let combinedData = {};
      if (!res[0].data.length || !res[1].data.length) return;

      res[0].data.forEach((item, index) => {
        _.set(combinedData, `${item.datetime}.pcpn`, item.value);
      });

      res[1].data.forEach((item, index) => {
        _.set(combinedData, `${item.datetime}.evaporation`, item.value);
      });

      const dates = Object.keys(combinedData);
      let csv = 'Date,EPL_1H,Hourly Rainfall,Net Evaporation\n'
      let data = [];
      let table = [];
      dates.forEach((date, i) => {
        const eva = i == 0 ? null : combinedData[dates[i - 1]].evaporation - combinedData[date].evaporation + combinedData[dates[i]].pcpn
        data.push([getDisplayDate(date, { returnMills: true }), eva]);
        csv += `${getDisplayDate(date)},${combinedData[date].evaporation},${combinedData[date].pcpn},${eva || ''}\n`;
        table.push({
          datetime: getDisplayDate(date),
          epl_1h: combinedData[date].evaporation,
          pcpn: combinedData[date].pcpn,
          evaporation: Math.floor(eva * 100) / 100,
        });
      })
      data = data.slice(1);

      this.setState({
        csv,
        table,
        options: {
          chart: {
            type: 'column',
            zoomType: 'x',
          },
          title: {
            text: '',
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%Y-%m-%d',
              month: '%Y-%m',
              year: '%Y'
            },
          },
          yAxis: {
            title: {
              text: this.state.unit,
            },
          },
          tooltip: {
            crosshairs: true,
            shared: true,
          },
          series: [{
            name: 'Pan Evaporation',
            data
          }],
        }
      });


    }).catch(err => {
      notify.error(err.message);
    }).finally(() => {
      this.loading = false;
    })
  }

  exportCSV = (e) => {
    e.preventDefault();

    let hiddenElement = document.createElement('a');
    document.body.appendChild(hiddenElement);
    let csvData = new Blob([this.state.csv], { type: 'text/csv' });
    hiddenElement.href = URL.createObjectURL(csvData);
    // hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
    hiddenElement.target = '_blank';
    hiddenElement.download = 'Evaporation.csv';
    hiddenElement.click();
  };

  render() {
    const { stationStore, parameterStore } = this.props;

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput
              label={'Station'}
              value={this.filters.station_id}
              fields={{ label: 'name', value: 'id' }}
              options={stationStore.items}
              onChange={this.onChangeStationFilter}
              filterOptions={stationStore.filterStations}
              isLoading={stationStore.isLoading}
            />
            <SelectInput
              label={'Evaporation'}
              value={this.filters.evaporation_id}
              fields={{ label: 'name', value: 'id' }}
              options={this.dataSeriesItems}
              onChange={e => this.onChangeFilter('evaporation_id', e)}
              filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
            />
            <SelectInput
              label={'Precipitation'}
              value={this.filters.pcpn_id}
              fields={{ label: 'name', value: 'id' }}
              options={this.dataSeriesItems}
              onChange={e => this.onChangeFilter('pcpn_id', e)}
              filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
            />
            <DateInput
              label={'Date From'}
              value={this.filters.date_from}
              onChange={e => this.onChangeFilter('date_from', e)}
            />
            <DateInput
              label={'Date To'}
              value={this.filters.date_to}
              onChange={e => this.onChangeFilter('date_to', e)}
            />
          </FormBody>
          <FormActions>
            <div className='inline-grid'>
              <div>
                <button onClick={this.onView}>View</button>
                <button onClick={this.exportCSV}>Download CSV</button>
              </div>
              <div>
                <div className='TabBar TabBarRounded'>
                  <ul>
                    <li className={this.graph ? 'active' : ''} onClick={() => this.graph = true}><a>Graph</a></li>
                    <li className={!this.graph ? 'active' : ''} onClick={() => this.graph = false}><a>Table</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </FormActions>
        </Form>
        <div>
          {this.loading && <Spinner />}
          {!this.loading && !!this.state.options &&
            (this.graph ?
              <GraphView options={this.state.options} /> :
              <DataTable data={this.state.table.sort((a, b) => new Date(a.datetime).valueOf() < new Date(b.datetime).valueOf() ? 1 : -1)} columns={this.tableCols} />
            )
          }
        </div>
      </div>
    )
  }
}

export default Evaporation;


// WEBPACK FOOTER //
// ./src/components/Analysis/Evaporation.js